import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResidencyFacultyModel } from '@shared/models/data/residency-faculty-model';
import { EnrollmentService } from '@shared/services/enrollment.service';

@Component({
  selector: 'aaos-remove-faculty-dialog',
  templateUrl: './remove-faculty-dialog.component.html',
  styleUrls: ['./remove-faculty-dialog.component.scss']
})
export class RemoveFacultyDialogComponent {

  loading = false;
  removeFacultyError = false;

  constructor(@Inject(MAT_DIALOG_DATA) public facultyMember: ResidencyFacultyModel,
              public dialogRef: MatDialogRef<RemoveFacultyDialogComponent>,
              private enrollmentService: EnrollmentService) {  }


  removeFaculty() {
    this.loading = true;
    this.enrollmentService.removeFaculty(this.facultyMember.contactWebRoleId).subscribe(resp => {
        this.loading = false;

        if (resp === true) {
          this.dialogRef.close();
        } else {
          this.removeFacultyError = true;
        }
    });
  }

}
